<template>

  <v-layout row justify-center>

    <v-snackbar :timeout="30000" color="info" :multi-line="true" :vertical="false" v-model="ios" :auto-height="true">
      <v-btn dark @click.native="install()" class="px-3" color="orange">
        <v-icon left dark>get_app</v-icon>
        Instalar
      </v-btn>
      <v-btn dark flat @click.native="ios = false">Fechar</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="info">
          <v-toolbar-title>Instalar no Dispositivo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialog = false">Fechar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-img src="/static/img/ios.png" contain alt="Adicionando à tela inicial no iOS" class="mt-3" />
      </v-card>
    </v-dialog>

  </v-layout>

</template>

<script>
import mobile from 'mobile-device-detect'

export default {
  data () {
    return {
      ios: false,
      dialog: false
    }
  },
  mounted () {
    if (mobile.isIOS && window.navigator.standalone !== true && !window.matchMedia('(display-mode: standalone)').matches && this.$localStorage.iosTryInstall) {
      this.ios = true
    }
  },
  methods: {
    install () {
      this.ios = false

      this.dialog = true

      this.$localStorage.set('iosTryInstall', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Install.vue